export default __webpack_public_path__ + "static/media/setting.79d3640c.svg";